import module from 'colaborador/module.js'

const schema = {
  id: 'number',
  importe: 'number',
  abonado: 'number',
  conluido: 'boolean',
  fecha: 'date',
}

export class ColaboradorPrestamosExternosService {
  constructor ($http) {
    this.$http = $http
  }

  get (idProyecto, idColaborador) {
    return this.$http.get('/api/colaborador/prestamos-externos', {
      params: {idProyecto, idColaborador},
      schema,
    })
  }

  post (idProyecto, idColaborador, personaId, manual, data) {
    return this.$http.post('/api/colaborador/prestamos-externos', data, {
      params: {idProyecto, idColaborador, personaId, manual},
      schema: {  
        conceptoId: 'number',
        fechaInicial: 'date',
        importe: 'number',
        plazos: 'number',
      },
    })
  }
}

module.service('ColaboradorPrestamosExternos', ColaboradorPrestamosExternosService)



// WEBPACK FOOTER //
// ./src/colaborador/services/Colaborador/PrestamosExternos.js